export default __webpack_public_path__ + "static/media/Welcome.e4838112.md";